<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <!-- <Create
      :createDialog="categoryCreateDialog"
      @close="categoryCreateDialog = false"
      @submit="getCategory"
    ></Create> -->
    <v-card grid-list-md>
      <ModelTitle title="Edit Account" @close="close()" />
      <v-container>
        <v-row>
          <v-col cols="12" sm="12">
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <ImageView
                  :name="searchName"
                  field="product"
                  @submit="imageChange"
                />
                <!-- <v-card height="100%" min-height="100" outlined>
                  <v-hover v-if="Product.imageUrl" v-slot:default="{ hover }">
                    <v-img
                      height="100%"
                      aspect-ratio="1"
                      :src="Product.imageUrl"
                    >
                      <v-layout
                        v-if="hover"
                        column
                        fill-height
                        justify-center
                        align-center
                      >
                        <v-flex shrink>
                          <v-btn
                            @click="Product.imageUrl = null"
                            color="error"
                            fab
                            small
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-hover>
                  <v-img
                    v-else
                    height="100%"
                    src="https://www.esm.rochester.edu/uploads/NoPhotoAvailable-335x419.jpg"
                  >
                  </v-img>
                </v-card> -->
              </v-col>
              <v-col sm="12" md="9">
                <v-row align="center">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="Product.name"
                      :error-messages="nameErrors"
                      autofocus
                      :hide-details="nameErrors.length === 0"
                      outlined
                      @change="changeName"
                      @focus="$event.target.select()"
                      dense
                      label="Name"
                      ref="productName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      v-model="Product.price"
                      class="right-input"
                      label="Price"
                      outlined
                      dense
                      hide-details
                      @focus="$event.target.select()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Product Active"
                      hide-details
                      outlined
                      dense
                      v-model="Product.active"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Fee base product"
                      hide-details
                      outlined
                      dense
                      v-model="Product.isFee"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-checkbox
                      label="Public donation account"
                      hide-details
                      outlined
                      dense
                      v-model="Product.publicDonation"
                      @change="resetMerchant"
                    ></v-checkbox>
                  </v-col>
                  <!-- <v-col cols="12" sm="12">
                    <v-select
                      :items="Category"
                      clearable
                      :hide-details="selectCategoryError.length === 0"
                      :error-messages="selectCategoryError"
                      v-model="Product.CategoryId"
                      item-text="name"
                      outlined
                      dense
                      item-value="id"
                      label="Select Category"
                    >
                      <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item @click="categoryCreateDialog = true">
                          <v-list-item-content>
                            <v-list-item-title
                              >Create New Category</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <!-- <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.cost"
              @focus="$event.target.select()"
              class="right-input"
              outlined
              hide-details
              dense
              label="Purchase Cost"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.price"
              class="right-input"
              label="Price"
              outlined
              dense
              hide-details
              @focus="$event.target.select()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="Product.balance"
              class="right-input"
              hide-details
              disabled
              outlined
              dense
              @focus="$event.target.select()"
              label="Current Stock"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Track Inventory"
              hide-details
              outlined
              dense
              :disabled="trackInventory"
              v-model="Product.trackInventory"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Track Serial Number"
              hide-details
              outlined
              dense
              v-model="Product.trackSerialNumber"
            ></v-checkbox>
          </v-col> -->

          <!-- <v-col cols="12" sm="12" md="4">
            <v-checkbox
              label="Remote Ordering"
              hide-details
              outlined
              dense
              v-model="Product.remoteOrder"
            ></v-checkbox>
          </v-col> -->
          <v-col v-if="Product.publicDonation" cols="12" sm="12" class="py-0">
            <v-select :loading="loading" item-value="id" item-text="name"
            single-line v-model="Product.MerchantAccountId"
            outlined dense :items="merchants"
            label="Select Merchant Account"></v-select>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea
              counter="counter"
              hide-details
              outlined
              dense
              auto-grow
              v-model="Product.note"
              :label="$t('labels.description')"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>
      <v-card-actions>
        <!-- <MoreImage :imageResult="imageResult" @submit="imageChange" /> -->

        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="update()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import productService from "../service.js";
import merchantService from "@/modules/Merchant/service.js";
import ImageView from "@/components/Image/ImageView";
// import categoryService from "@/modules/Product/Category/service";
import GlobalFunction from "@/mixins/GlobalFunction";
// import _ from "lodash";

const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
// const Create = () => import("@/modules/Product/Category/components/Create");

export default {
  props: {
    editDialog: {
      default: false,
    },
    id: {
      default: 0,
    },
  },
  name: "edit-product",
  data() {
    return {
      searchName: null,
      categoryCreateDialog: false,
      Category: [],
      merchants: [],
      imageResult: null,
      selectedCategory: null,
      dialog: false,
      loading: false,
      trackInventory: false,
      Product: {
        name: null,
        note: null,
        price: 0,
        cost: 0,
        imageUrl: null,
        trackSerialNumber: false,
        balance: 0,
        trackInventory: false,
        active: true,
        MerchantAccountId: null,
      },
    };
  },
  components: {
    // Create,
    ImageView,
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Product: {
      name: {
        required,
        minLength: minLength(5),
      },
    },
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Product.name.$dirty) return errors;
      if (!this.$v.Product.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Product.name.minLength)
        errors.push("Field must be at least 5 characters long");
      return errors;
    },
    // selectCategoryError() {
    //   const errors = [];
    //   if (!this.$v.Product.CategoryId.$dirty) return errors;
    //   if (!this.$v.Product.CategoryId.required)
    //     errors.push(this.$t("validations.fieldIsRequired"));
    //   if (!this.$v.Product.CategoryId.minValue)
    //     errors.push("Pleaes select category");

    //   return errors;
    // },
  },
  watch: {
    Product: {
      handler(val) {
        if (val.trackSerialNumber) {
          this.Product.trackInventory = false;
          this.trackInventory = false;
        } else {
          this.trackInventory = false;
        }
      },
      deep: true,
    },
    editDialog(val) {
      this.dialog = val;
      if (val) {
        this.getMerchanAccount()
        this.loadProduct();
      }
    },
  },
  methods: {
    resetMerchant(){
      this.Product.MerchantAccountId = null
    },
    getMerchanAccount(){
      this.loading = true;
      merchantService.getAll().then(response => {
        
        this.loading = false;
        this.merchants = response.data
      }).catch(error => {
        this.loading = false;
        console.log('error getting merchants', error)
      })
    },
    loadProduct() {
      return productService.getById(this.id).then((result) => {
        console.log("produ", result);
        this.Product = result.data;
      });
    },
    imageChange(val) {
      if (val) {
        this.Product.imageUrl = val;
      }
    },
    changeName() {
      this.Product.name = this.properCase(this.Product.name);
      this.searchName = this.Product.name;
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    // getCategory() {
    //   this.loading = true;
    //   return categoryService.getAll().then((response) => {
    //     this.loading = false;
    //     this.Category = response.data;
    //     return response;
    //   });
    // },
    empty() {
      this.Product = {
        name: null,
        note: null,
        price: 0,
        CategoryId: null,
        imageUrl: null,
        cost: 0,
        trackSerialNumber: false,
        balance: 0,
        trackInventory: false,
        active: true,
        MerchantAccountId: null,
        image: {},
      };
      this.imageUrl = null;
      this.imageResult = null;
      this.$v.$reset();
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;

        console.log("editProduct, ", this.Product);
        return productService
          .update(this.Product.id, this.Product)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Product is updated",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log("err", err);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
